import { Dispatch, SetStateAction, useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { addErrorToast } from '../../../components/errors/toast/ToastUtils';
import { deleteForm as deleteFormService } from '../../../services/form/FormService';
import { useIntl } from 'react-intl';

interface Values {
  isLoading: boolean;
  deleteForm: (id: string) => Promise<boolean>;
  setOrganizationId: Dispatch<SetStateAction<string>>;
}

const useDeleteForm = (organizationId: string): Values => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [id, setOrganizationId] = useState<string>(organizationId);
  const intl = useIntl();
  const deleteForm = async (formId: string): Promise<boolean> => {
    try {
      setIsLoading(true);
      const result = await deleteFormService(id, formId);
      if (result.data === 1) {
        setIsLoading(false);
        return true;
      } else {
        setIsLoading(false);
        addErrorToast({ message: intl.formatMessage({ id: 'errors.generic' }) });
        return false;
      }
    } catch (error) {
      handleError(error);
      setIsLoading(false);
      return false;
    }
  };

  return { deleteForm, isLoading, setOrganizationId };
};

export default useDeleteForm;
